module.exports = __webpack_public_path__ + "media/music/f9868658d8483a6dbcd600e0226dfeef.mp3";